// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import {
    CheckboxFieldDefinition,
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import MobiusPage from "@insite/mobius/Page";
import * as React from "react";

const ForValvesCustomers: CheckboxFieldDefinition = {
    name: "forValvesCustomers",
    displayName: "For Valves Customers",
    editorTemplate: "CheckboxField",
    defaultValue: false,
    fieldType: "General",
    tooltip: "If selected, this page will be visible to customers with the 'Valves' customer type.",
};

const ForKrebsExpressPumpsCustomers: CheckboxFieldDefinition = {
    name: "forKrebsExpressPumpsCustomers",
    displayName: "For Krebs Express Pumps Customers",
    editorTemplate: "CheckboxField",
    defaultValue: false,
    fieldType: "General",
    tooltip: "If selected, this page will be visible to customers with the 'Krebs Express pumps' customer type.",
};

const ForDoePumpsCustomers: CheckboxFieldDefinition = {
    name: "forDoePumpsCustomers",
    displayName: "For DOE Pumps Customers",
    editorTemplate: "CheckboxField",
    defaultValue: false,
    fieldType: "General",
    tooltip: "If selected, this page will be visible to customers with the 'DOE pumps' customer type.",
};

const ForCyclonesCustomers: CheckboxFieldDefinition = {
    name: "forCyclonesCustomers",
    displayName: "For Cyclones Customers",
    editorTemplate: "CheckboxField",
    defaultValue: false,
    fieldType: "General",
    tooltip: "If selected, this page will be visible to customers with the 'Cyclones' customer type.",
};

const RestrictedProductLinePage: React.FunctionComponent<PageProps> = ({ id }) => (
    <MobiusPage>
        <Zone contentId={id} zoneName="Content" />
    </MobiusPage>
);

const pageModule: PageModule = {
    component: RestrictedProductLinePage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "Content",
        allowedChildren: [],
        fieldDefinitions: [
            ForValvesCustomers,
            ForKrebsExpressPumpsCustomers,
            ForDoePumpsCustomers,
            ForCyclonesCustomers,
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
                sortOrder: 199,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;
